import { HelpDialogComponent } from './../help-dialog/help-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-inline-help-button',
  templateUrl: './inline-help-button.component.html',
  styleUrls: ['./inline-help-button.component.css']
})
export class InlineHelpButtonComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  content: string;

  constructor(private matDialog: MatDialog) { }

  ngOnInit() {
  }

  showDialog() {
    this.matDialog.open(HelpDialogComponent, {
      data: { title: this.title, content: this.content },
      maxWidth: 600
    });
  }

}
